import React from 'react';
import { servicesData } from '../data/mock';
import { Briefcase, GraduationCap, Users, Monitor, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';

const iconMap = {
  Briefcase,
  GraduationCap,
  Users,
  Monitor
};

const Services = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-24 bg-purple-200/50 relative overflow-hidden">
      {/* Background Elements - contained within section */}
      <div className="absolute top-20 right-20 w-96 h-96 bg-[#7ed321]/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-20 left-20 w-80 h-80 bg-[#6b2d7b]/10 rounded-full blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#6b2d7b] mb-4">
            {servicesData.title}
          </h2>
          <p className="text-xl text-slate-600">
            {servicesData.subtitle}
          </p>
        </div>

        {/* Services Grid - 2x2 */}
        <div className="grid md:grid-cols-2 gap-8">
          {servicesData.services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group bg-white rounded-3xl p-8 lg:p-10 border border-slate-100 hover:border-[#6b2d7b]/30 transition-all duration-300 hover:shadow-xl hover:shadow-[#6b2d7b]/10"
              >
                {/* Service Header */}
                <div className="flex items-start gap-5 mb-6">
                  <div className="w-14 h-14 rounded-2xl bg-[#7ed321] flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="w-7 h-7 text-[#2d1b38]" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-[#6b2d7b] mb-2">
                      {service.title}
                    </h3>
                    <p className="text-slate-600">
                      {service.description}
                    </p>
                  </div>
                </div>

                {/* Features List */}
                <ul className="space-y-3 mb-6">
                  {service.features.map((feature, idx) => (
                    <li
                      key={idx}
                      className="flex items-start gap-3 text-slate-600"
                    >
                      <CheckCircle2 className="w-5 h-5 text-[#7ed321] flex-shrink-0 mt-0.5" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* Tagline */}
                <div className="pt-4 border-t border-slate-100">
                  <p className="text-[#6b2d7b] font-medium italic">
                    {service.tagline}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Button
            onClick={scrollToContact}
            className="bg-[#7ed321] hover:bg-[#6bc11a] text-[#2d1b38] font-semibold px-8 py-6 text-lg"
          >
            Schedule a Consultation
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Services;
